import React, { useEffect, useState } from "react";
import { UnoStoreHooks } from "@simulanisindia/ui";
import { CopyIcon, DeleteIcon, EditIcon, MoveDownIcon, MoveUpIcon } from "../../Assest/icons/icons";
import AddTask from "./AddTask";
import apiClient from "../../apiClient";
import { useParams } from "react-router-dom";
import { XR_MODULE_TASK_SCENARIO } from "../../apiClient/apiEndpoints";
import AddScenarioModal from "../modals/AddScenarioModal";
import DeleteTaskModal from "../modals/DeleteTaskModal";
import EditTask from "./EditTask";

const { useUnoSelector } = UnoStoreHooks;

const Tasklist = () => {
  const [drag, setDrag] = useState(false);
  const params = useParams();
  const [locked, setLocked] = useState(false);
  const [reorder, setReorder] = useState(false);
  const uuid = params?.id;
  const [moduleName, setModuleName] = useState(null);
  const [moduleID, setModuleID] = useState(null);
  const configData = useUnoSelector((state) => state.config);
  const userData = useUnoSelector((state) => state.user);
  const [showAddTask, setShowAddTask] = useState(false);
  const [showEditTask, setShowEditTask] = useState(false);
  const [showCsvModule, setShowCsvModule] = useState(false);
  const [showScenario, setShowScenario] = useState(false);
  const [editValue, setEditValue] = useState({});
  const [moduleTaskList, setModuleTaskList] = useState([]);
  const [scenarioList, setScenarioList] = useState([]);
  const [showAddTaskModal, setShowAddTaskModal] = useState(false);
  const [showEditTaskModal, setShowEditTaskModal] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [showAddScenarioModal, setShowAddScenarioModal] = useState(false);
  const [showDeleteTaskModal, setShowDeleteTaskModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const handleAddTask = () => {
    setShowAddTaskModal(true);
  };

  const handleEditTask = (task) => {
    setSelectedTask(task);
    setShowEditTaskModal(true);
  };

  const handleAddScenario = () => {
    setShowAddScenarioModal(true);
  };

  const closeAddTaskModal = () => {
    setShowAddTaskModal(false);
  };

  const closeEditTaskModal = () => {
    setShowEditTaskModal(false);
    setSelectedTask(null);
  };

  const getModuleTaskList = async () => {
    try {
      let data = await apiClient.get(`${configData.config.UNO_URL}${XR_MODULE_TASK_SCENARIO}/${uuid}`);

      setModuleName(data?.name);
      setModuleID(data?.legacyId);
      let tasks = data?.children[0]?.versions[0]?.data?.tasks || [];
      let scenarios = data?.children[0]?.versions[0]?.data?.scenarios || [];

      setModuleTaskList(tasks);
      setScenarioList(scenarios);
      if (data?.children[0]?.versions[0]?.data?.lock) {
        setLocked(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getModuleTaskList();
  }, [uuid]);

  const handleShowAddTask = () => setShowAddTask(true);
  const handleCloseAddTask = () => setShowAddTask(false);

  const handleShowScenario = () => setShowScenario(true);
  const handleCloseScenario = () => setShowScenario(false);

  const handleCloseEditTask = () => setShowEditTask(false);
  const handleCloseCsvModule = () => setShowCsvModule(false);

  const handleShowEditTask = (data) => {
    setShowEditTask(true);
    setEditValue({ ...data });
  };

  const closeDeleteTaskModal = () => {
    setShowDeleteTaskModal(false);
    setSelectedTask(null);
  };

  const onConfirmDeleteTask = async () => {
    try {
      setDeleteLoading(true);
    } finally {
      setDeleteLoading(false);
      closeDeleteTaskModal();
    }
  };

  const handleSaveAndProceed = async (taskList) => {
    try {
      let data = {
        tasks: Array.isArray(taskList) ? taskList : moduleTaskList,
      };

      await apiClient.post(`${configData.config.UNO_URL}${XR_MODULE_TASK_SCENARIO}/${uuid}`, data);
    } catch (error) {
      alert("Something went wrong.");
    } finally {
      getModuleTaskList();
    }
  };

  const handleSaveScenario = async (list) => {
    try {
      let data = {
        scenarios: list,
      };
      await apiClient.post(`${configData.config.UNO_URL}${XR_MODULE_TASK_SCENARIO}/${uuid}`, data);

      if (list.length === 1 && moduleTaskList.length > 0) {
        let updatedTaskList = moduleTaskList.map((e) => ({ ...e, scenario: list[0].id }));
        handleSaveAndProceed(updatedTaskList);
        return;
      }
      getModuleTaskList();
    } catch (error) {
      console.log(error);
    }
  };
  const updateTaskListDeleteScenario = (id) => {
    let taskList = moduleTaskList.map((task) => (task.scenario == id ? { ...task, scenario: null } : task));
    if (taskList.length) {
      setModuleTaskList(taskList);
      handleSaveAndProceed(taskList);
    }
  };
  const addNewTaskToList = (newTask) => {
    let taskList = [...moduleTaskList, newTask];

    if (locked) {
      taskList = taskList.map((item) => ({
        ...item,
        id: Number(item.id),
        priority: Number(item.priority),
      }));
    } else {
      taskList = taskList.map((item, index) => ({
        ...item,
        id: Number(index + 1),
        priority: Number(item.priority),
      }));
    }
    setModuleTaskList(taskList);
    handleCloseAddTask();
    handleSaveAndProceed(taskList);
  };

  const saveEditTask = (value) => {
    var taskList = [...moduleTaskList];
    var index = taskList.findIndex((e) => e.id == value.id);
    if (index !== -1) {
      taskList[index] = value;
      if (locked) {
        taskList = taskList.map((item) => ({
          ...item,
          priority: Number(item.priority),
        }));
      } else {
        taskList = taskList.map((item) => ({
          ...item,
          id: Number(item.id),
          priority: Number(item.priority),
        }));
      }

      setModuleTaskList(taskList);
      handleSaveAndProceed(taskList);
    }
    handleCloseEditTask();
  };

  const handleDeleteTask = (index) => {
    var taskList = [...moduleTaskList];
    taskList.splice(index, 1);
    setModuleTaskList(taskList);
    handleSaveAndProceed(taskList);
  };

  return (
    <div className="taskList">
      <div className="taskList-main">
        <div className="tasklist-wrapper">
          <div className="tasklist-head">
            <p>Task List</p>
            <div className="tasklist-head-wrapper">
              {/* <button className="actionButton">Task CSV</button> */}
              <button className="actionButton" onClick={handleShowAddTask}>
                Add Task
              </button>
              <button className="actionButton" onClick={handleShowScenario}>
                Add Scenario
              </button>
            </div>
          </div>

          {moduleTaskList.map((item, index) => (
            <div className="task-item-main">
              <div className="task-item-head">
                <p>Task {index + 1}</p>
                <div className="task-head-functions">
                  {/* <button> <MoveUpIcon /> Move Up </button>
                  <button> <MoveDownIcon /> Move Down </button> */}
                  <button onClick={() => handleDeleteTask(index)}>
                    {" "}
                    <DeleteIcon /> Delete{" "}
                  </button>
                  <button onClick={() => handleShowEditTask({ ...item })}>
                    <EditIcon /> Edit
                  </button>
                </div>
              </div>
              <div className="task-body">
                <div className="task-lil-info">
                  <div className="info-options">
                    <p>
                      Task ID : <strong> {item.id} </strong>
                    </p>
                    <p>
                      Priority : <strong> {item.priority} </strong>
                    </p>
                    <p>
                      Time : <strong> {item.plannedTime}</strong>
                    </p>
                  </div>
                  {item.isCritical ? (
                    <span className="critical"> Critical </span>
                  ) : (
                    <span className="not-critical"> Not Critical </span>
                  )}
                </div>
                <div className="task-main-info">
                  <div className="for-name">
                    <p className="name">Task Name :</p>
                    <p className="ans">{item.title}</p>
                  </div>
                  <div className="for-name">
                    <p className="name">Task Description :</p>
                    <p className="ans">{item.taskDesc}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <AddTask
        showAddTask={showAddTask}
        handleClose={closeAddTaskModal}
        handleCloseAddTask={handleCloseAddTask}
        addNewTaskToList={addNewTaskToList}
        scenarioList={scenarioList}
        locked={locked}
      />

      <EditTask
        showEditTask={showEditTask}
        handleCloseEditTask={handleCloseEditTask}
        saveEditTask={saveEditTask}
        scenarioList={scenarioList}
        editValue={editValue}
      />

      <AddScenarioModal
        showScenario={showScenario}
        handleCloseScenario={handleCloseScenario}
        handleSaveScenario={handleSaveScenario}
        scenarioList={scenarioList}
        updateTaskListDeleteScenario={updateTaskListDeleteScenario}
      />

      <DeleteTaskModal
        show={showDeleteTaskModal}
        handleClose={closeDeleteTaskModal}
        onConfirm={onConfirmDeleteTask}
        loading={deleteLoading}
      />
    </div>
  );
};

export default Tasklist;
